import React from "react";
import useReveal from "../../hooks/useReveal";

const services = [
  {
    tag: "ADS",
    title: "Imágenes publicitarias",
    desc: "Diseños para promociones, historias, estados de WhatsApp y anuncios digitales.",
  },
  {
    tag: "PLAY",
    title: "Videos publicitarios con IA",
    desc: "Videos cortos para reels, historias, estados, anuncios o campañas de temporada.",
  },
  {
    tag: "IA",
    title: "Imágenes tipo fotografía con IA",
    desc: "Visuales realistas para representar productos, servicios y escenas comerciales.",
  },
];

const Services = () => {
  useReveal();
  return (
    <section
      id="servicios"
      data-testid="section-servicios"
      className="bdk-section"
      style={{ background: "var(--paper)" }}
    >
      <div className="container-bdk">
        <div className="max-w-[760px] mx-auto text-center mb-14 bdk-reveal bdk-reveal--up">
          <p className="kicker">Contenido creativo</p>
          <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
            Imágenes y videos para promocionar
            <br />
            tu negocio en redes y anuncios.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-[900px] mx-auto">
          {services.map((s, i) => (
            <article
              key={s.title}
              data-testid={`servicio-card-${i}`}
              className="p-7 rounded-[12px] bg-white bdk-reveal bdk-reveal--up transition-all"
              style={{
                border: "1px solid var(--line)",
                "--reveal-delay": `${i * 70}ms`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.borderColor = "rgba(217,0,32,.4)";
                e.currentTarget.style.boxShadow =
                  "0 18px 40px rgba(17,18,24,.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "";
                e.currentTarget.style.borderColor = "var(--line)";
                e.currentTarget.style.boxShadow = "";
              }}
            >
              <div
                className="grid place-items-center w-[52px] h-[52px] mb-5 rounded-[10px] text-white font-display font-black text-[16px]"
                style={{ background: "var(--red)" }}
              >
                {s.tag}
              </div>
              <h3 className="font-display text-[25px] leading-none">
                {s.title}
              </h3>
              <p className="mt-3 text-[#666873] text-[13px]">{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
